import * as React from 'react';
import TableViz from './Table';
import NumberViz from './Number';

class ExceptionViz extends React.PureComponent<any, any> {
  render() {
    const { formData } = this.props;
    return (formData.exception_card_type === 'table') ?
      (<TableViz {...this.props}></TableViz>) :
      (<NumberViz {...this.props}></NumberViz>);
  }
}
export default ExceptionViz;
